import { Instagram, Twitter, Youtube } from "lucide-react";

const socialPlaceholders = [
  { name: "Instagram", Icon: Instagram, testid: "footer-social-instagram" },
  { name: "X / Twitter", Icon: Twitter, testid: "footer-social-twitter" },
  { name: "YouTube", Icon: Youtube, testid: "footer-social-youtube" },
];

export default function Footer() {
  return (
    <footer className="relative overflow-hidden bg-[#1C130E] px-6 pb-10 pt-20 sm:px-12 lg:px-20" data-testid="site-footer">
      <p
        aria-hidden="true"
        className="font-display pointer-events-none absolute -bottom-8 left-1/2 -translate-x-1/2 select-none whitespace-nowrap text-[22vw] uppercase leading-none tracking-tighter text-[#F4EEE3]/[0.04]"
      >
        Sanzone
      </p>
      <div className="relative mx-auto max-w-7xl">
        <div className="grid gap-12 md:grid-cols-12">
          <div className="md:col-span-5">
            <p className="font-caps text-lg font-semibold uppercase tracking-[0.4em] text-[#F4EEE3]" data-testid="footer-wordmark">
              Sanzone
            </p>
            <p className="font-code mt-3 text-[11px] uppercase tracking-[0.35em] text-[#C4A05C]">The First Wolf</p>
            <p className="font-code mt-1.5 text-[11px] uppercase tracking-[0.35em] text-[#F4EEE3]/60">Instinct. Refined.</p>
            <p className="mt-5 max-w-xs text-xs leading-relaxed text-[#8C857B]">
              Original street apparel and couture by Toriano Sanzone. Public launch: April 2027.
            </p>
          </div>

          <div className="md:col-span-3">
            <p className="font-code text-[10px] uppercase tracking-[0.35em] text-[#B0A894]">Social Coordinates</p>
            <div className="mt-5 flex gap-4">
              {socialPlaceholders.map(({ name, Icon, testid }) => (
                <span
                  key={name}
                  title={`${name} — placeholder: add the real account URL before launch`}
                  aria-label={`${name} (placeholder — link not yet set)`}
                  aria-disabled="true"
                  className="flex h-10 w-10 cursor-not-allowed items-center justify-center border border-[#F4EEE3]/20 text-[#8C857B]"
                  data-testid={testid}
                >
                  <Icon className="h-4 w-4" />
                </span>
              ))}
            </div>
            <p className="mt-3 text-[11px] text-[#8C857B]">Placeholders — real account URLs to be added before launch.</p>
          </div>

          <div className="md:col-span-4">
            <p className="font-code text-[10px] uppercase tracking-[0.35em] text-[#B0A894]">Contact & Privacy</p>
            <ul className="mt-5 space-y-3 text-xs leading-relaxed text-[#8C857B]">
              <li>
                <a
                  href="mailto:toriano@torianosanzone.com"
                  className="text-[#F4EEE3] underline decoration-[#9A7B3F]/60 underline-offset-4 transition-colors duration-300 hover:text-[#C4A05C]"
                  data-testid="footer-contact-email"
                >
                  toriano@torianosanzone.com
                </a>
              </li>
              <li data-testid="footer-privacy-placeholder">Privacy notice — placeholder: policy link to be added before launch.</li>
              <li>Waitlist and application entries are stored privately, never shown publicly, and are exportable by the owner as CSV.</li>
              <li>Promotional email is opt-in only. No SMS is collected.</li>
            </ul>
          </div>
        </div>

        <div className="mt-16 flex flex-col gap-3 border-t border-[#F4EEE3]/15 pt-8 sm:flex-row sm:items-center sm:justify-between">
          <p className="font-code text-[11px] uppercase tracking-[0.3em] text-[#8C857B]">
            © 2026 SANZONE · Toriano Sanzone
          </p>
          <p className="font-code text-[11px] uppercase tracking-[0.3em] text-[#8C857B]">
            Wear the art · Lead the pack
          </p>
        </div>
      </div>
    </footer>
  );
}
